<table>
    <thead>
        <tr>
            <th>
                Field
            </th>
            <th>
                Current Value
            </th>

            <th>
                Desired Value
            </th>

            <th>
                Status
            </th>
        </tr>
    </thead>

    <tbody>

        <!-- User Risk  -->
        <tr>
            <td>
                User risk
                <mat-icon
                    matTooltip="User risk level is the likelihood that the user account is compromised.">info</mat-icon>
            </td>

            <td>
                <mat-label *ngFor="let item of policy?.conditions?.userRiskLevels">
                    {{item}}
                </mat-label>
            </td>

            <td>
                <app-magic-multi-selector [title]="'User risk level'" [controller]="userSignInRiskLevelsController"
                    [lookup]="userSignInRiskLevelsLookup">

                </app-magic-multi-selector>

            </td>

            <td>
                <sway-baseline-status  *ngIf="policy?.id" [hasError]="errorsString?.includes('userRiskLevels') ">
                </sway-baseline-status>

            <mat-icon *ngIf="!policy?.id" class="warn-icon" matTooltip="Baseline is not associated with any policy">warning</mat-icon>

            </td>
        </tr>

        <!-- sigIn Risk  -->

        <tr>
            <td>
                Sign-in risk
                <mat-icon
                    matTooltip="Sign-in risk level is the likelihood that the sign-in session is compromised.">info</mat-icon>
            </td>

            <td>
                <mat-label *ngFor="let item of policy?.conditions?.signInRiskLevels">
                    {{item}}
                </mat-label>
            </td>

            <td>

                <app-magic-multi-selector [title]="'Sign-in risk level'" [controller]="signInRiskLevelsController"
                    [lookup]="signInRiskLevelsLookup">

                </app-magic-multi-selector>
            </td>

            <td>
                <sway-baseline-status  *ngIf="policy?.id" [hasError]="errorsString?.includes('signInRiskLevels') ">
                </sway-baseline-status>

            <mat-icon *ngIf="!policy?.id" class="warn-icon" matTooltip="Baseline is not associated with any policy">warning</mat-icon>

            </td>
        </tr>


        <tr>
            <td>
                Insider risk

                <mat-icon
                    matTooltip="Insider risk assesses the user's risky data-related activity in Microsoft Purview Insider Risk Management.">info</mat-icon>
            </td>

            <td>
                <mat-label>
                    {{policy?.conditions?.['insiderRiskLevels']}}
                </mat-label>
            </td>

            <td>
                <app-magic-multi-selector [title]="'Insider risk level'" [controller]="insiderRiskLevelsController"
                    [lookup]="insiderRiskLevelsLookup">

                </app-magic-multi-selector>
            </td>

            <td>
                <sway-baseline-status  *ngIf="policy?.id" [hasError]="
                        errorsString?.includes('insiderRiskLevels')
                        || (!policy?.conditions?.['insiderRiskLevels'] && (insiderRiskLevelsController.value?.length > 0))
                        ">
                </sway-baseline-status>

            <mat-icon *ngIf="!policy?.id" class="warn-icon" matTooltip="Baseline is not associated with any policy">warning</mat-icon>

            </td>
        </tr>


        <tr>
            <td>
                Include platforms
                <mat-icon matTooltip="Platform the user is signing in from. For example, 'iOS">info</mat-icon>
            </td>

            <td>
                <mat-label *ngFor="let item of policy?.conditions?.platforms?.includePlatforms">
                    {{item}}
                </mat-label>
            </td>

            <td>
                <app-magic-multi-selector [title]="'Include platforms'" [magicField]="includePlatformMagicField"
                    [controller]="includePlatFormController" [lookup]="platFormsLookup">

                </app-magic-multi-selector>
            </td>

            <td>
                <sway-baseline-status   *ngIf="policy?.id" [hasError]="errorsString?.includes('includePlatforms')
                        || (!policy?.conditions?.platforms?.includePlatforms && (includePlatFormController.value?.length > 0))

                    ">
                </sway-baseline-status>

            <mat-icon *ngIf="!policy?.id" class="warn-icon" matTooltip="Baseline is not associated with any policy">warning</mat-icon>

            </td>
        </tr>

        <tr>
            <td>
                Exclude platforms
            </td>

            <td>
                <mat-label *ngFor="let item of policy?.conditions?.platforms?.excludePlatforms">
                    {{item}}
                </mat-label>
            </td>

            <td>
                <app-magic-multi-selector [title]="'Exclude platforms'" [controller]="excludePlatFormController"
                    [lookup]="platFormsLookup">

                </app-magic-multi-selector>
            </td>

            <td>
                <sway-baseline-status  *ngIf="policy?.id" [hasError]="
                    errorsString?.includes('excludePlatforms')
                    || (!policy?.conditions?.platforms?.excludePlatforms && (excludePlatFormController.value?.length > 0))
                    ">
                </sway-baseline-status>

            <mat-icon *ngIf="!policy?.id" class="warn-icon" matTooltip="Baseline is not associated with any policy">warning</mat-icon>

            </td>
        </tr>


        <tr>
            <td>
                Client apps
                <mat-icon
                    matTooltip="Control user access to target specific client applications not using modern authentication.">info</mat-icon>
            </td>

            <td>
                <mat-label *ngFor="let item of policy?.conditions?.clientAppTypes">
                    <!-- to match Azure UI -->
                    <ng-container *ngIf="item !=='all'">
                        {{clientAppsLookupObject [item]?.['name'] || item}}
                    </ng-container>
                </mat-label>
            </td>

            <td>
                <app-magic-multi-selector [title]="'Select the client apps this policy will apply to'"
                    [hint]="'if it is not configured it is default to include all client app types'"
                    [controller]="clientAppsController" [lookup]="clientAppsLookup">

                </app-magic-multi-selector>
            </td>

            <td>
                <sway-baseline-status  *ngIf="policy?.id" [hasError]="errorsString?.includes('clientAppTypes') ">
                </sway-baseline-status>

            <mat-icon *ngIf="!policy?.id" class="warn-icon" matTooltip="Baseline is not associated with any policy">warning</mat-icon>

            </td>
        </tr>

        <tr>
            <td>
                Authentication flows
                <mat-icon
                    matTooltip="How your organization uses certain authentication and authorization protocols and grants">info</mat-icon>
            </td>

            <td>
                <mat-label class="block" *ngFor="let item of transferMethodsCurrentValue">
                    {{ item}}
                </mat-label>
            </td>

            <td>
                <app-magic-multi-selector [title]="'Authentication flows'" [controller]="authenticationFlowsController"
                    [lookup]="authenticationFlowsLookup">

                </app-magic-multi-selector>
            </td>

            <td>
                <sway-baseline-status  *ngIf="policy?.id" [hasError]="
                    errorsString?.includes('authenticationFlows')
                    || authenticationFlowsStringValue?.length  !== transferMethodsCurrentValueString?.length
                    ">
                </sway-baseline-status>

            <mat-icon *ngIf="!policy?.id" class="warn-icon" matTooltip="Baseline is not associated with any policy">warning</mat-icon>

            </td>
        </tr>
    </tbody>
</table>
